import DataStore from 'flux/stores/DataStore.js'
import { Link } from 'react-router-dom';
import scrollToComponent from 'react-scroll-to-component'
import ReactGA from 'react-ga';

class Home extends React.Component {
  constructor () {
    super()

    ReactGA.pageview(window.location.pathname + window.location.search);

    const languages = DataStore.getAllLanguages()

    const split = window.location.pathname.split('/')

    let lang = 'sv'
    if (languages.includes(split[1])) {
      lang = split[1]
    }

    let slug = 'startsida'
    let readMore = 'Läs mer'
    switch (lang) {
      case 'en':
        slug = 'welcome'
        readMore = 'Read more'
        break;
      case 'fi':
        slug = 'tervetuloa'
        readMore = 'Lue lisää'
        break;
      default:
        break;
    }

    let pageData = DataStore.getPageBySlug(slug, lang);
    this.state = {
      intro: pageData.acf.intro,
      puff: pageData.acf.puff,
      sections: pageData.acf.sectionRepeater,
      blocks: pageData.acf.contentBlocks,
      readMore: readMore,
      lang: lang,
    }
  }

  scrollDown () {
    scrollToComponent(this.refs.readMore, {
      offset: -document.getElementById('header').clientHeight,
      align: 'top',
      duration: 400
    });
  }

  render() {
    return (
      <div>
        <div className="home__intro padding">
          <div className="home__logo__container">
            <div className="home__logo__container__w">
              <h1 className="home__logo">
                <span className="off">Anderssons Gästhem & Gårdsbageri</span>
                <span className="l1"></span>
                <span className="l2"></span>
                <span className="l3"></span>
              </h1>
            </div>
          </div>
          <div className="home__intro__wrap">
            { this.state.intro &&
              <div className="home__intro__content wysiwyg" dangerouslySetInnerHTML={{ __html: this.state.intro }}></div>
            }

            <a href="https://bergbostugor.com" className="home__intro__puff">Bergbo Stugor</a>
          </div>

          {/* <button className="home__intro__more" onClick={() => this.scrollDown()}>
            { this.state.readMore }
          </button> */}
        </div>

        {/* <div className="home__content" ref="readMore">
          { this.state.sections &&
            this.state.sections.map((item, index) => <PageContent key={`content`+index} title={item.title} content={item.content} link={item.link} imgRepeater={item.imgRepeater} more={this.state.readMore} lang={this.state.lang}/>)
          } 
        </div> */}

        {/* { this.state.blocks &&
          this.state.blocks.map((item) => <FeaturedBlock key="column1" item={item} lang={this.state.lang}/>)
        } */}
    
      </div>
    );

  }
}


class PageContent extends React.Component {
  render() {
    let page = undefined
    let template = undefined
    let to = undefined
    if (this.props.link) {
      page = DataStore.getPageById(this.props.link.ID, this.props.lang)
      template = page.template ? page.template.replace('.php', '')  : ''
      to = this.props.lang === 'sv' ? `/${page.slug}` : `/${this.props.lang}/${page.slug}`
    }


    return (
      <div className={`home__content__item home__content__item--${ this.props.imgRepeater.length}`}> 
        { this.props.imgRepeater &&
          this.props.imgRepeater.map((item, index) => 
            <div key={`img` + index} className="home__content__item__image">
              <img src={item.image.sizes.large}/>
            </div>
          )
        }
        <div className={`padding home__content__item__text home__content__item__text--${template}`}>
          <h2 className="home__content__item__title">{this.props.title}</h2>
          <div className="wysiwyg">
            <div dangerouslySetInnerHTML={{ __html: this.props.content }}></div>
            { page &&
              <Link
              key={page.id}
              to={to}
              className="home__content__item__link"
            >
              { this.props.more }
            </Link>
            }
            
          </div>
        </div>
      </div>
    )
  }
}

class FeaturedBlock extends React.Component {
  render() {
    let page = undefined
    let to = undefined
    if (this.props.item.pagelink) {
      page = DataStore.getPageById(this.props.item.pagelink.ID, this.props.lang)
      to = this.props.lang === 'sv' ? `/${page.slug}` : `/${this.props.lang}/${page.slug}`

    }
    return (
      <div className="page__box page__box--home">
        <div className="page__box__content">
          <div className="wysiwyg">
            <h3>{this.props.item.title}</h3>
            <p dangerouslySetInnerHTML={{ __html: this.props.item.excerpt }} />
            { page &&
              <Link
              key={page.id}
              to={to}
            >
              {this.props.item.linkTitle}
            </Link>
            }
            
          </div>
          { this.props.item.image &&
            <div className="page__box__image page__box__image--round">
              <img src={this.props.item.image.sizes.square}/>
            </div>
           }
          
        </div>
      </div>
    )
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/scripts/components/Home.js